import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';

const FindBooking = ({ message = '' }) => {
  const email = useSelector((state) => state.user?.email);
  const [submissionClass, setSubmissionClass] = useState(
    message ? 'alert-danger' : 'alert-info'
  );
  const [submissionMessage, setSubmissionMessage] = useState(message);

  const formSchema = Yup.object().shape({
    email: (() => {
      let validation = Yup.string();
      if (!email) {
        validation = Yup.string().required('Email address is required');
      }
      return validation;
    })(),
    reference: Yup.string().required('Booking reference is required'),
  });

  const onSubmit = (params, { setSubmitting, isSubmitting, resetForm }) => {
    if (isSubmitting) return;
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');
    EcomEngineAPI.securePayment(params).then((result) => {
      setSubmitting(false);

      if (result.status && result.status >= 299) {
        setSubmissionMessage(result.message);
        setSubmissionClass('alert-danger');
      } else if (result.message) {
        setSubmissionMessage(result.message);
        setSubmissionClass('alert-info');
        resetForm();
      }

      if (result.location) {
        window.location.href = result.location;
      }
    });
  };

  return (
    <div className="find-bookings">
      <Formik
        initialValues={{
          email: email || '',
          reference: '',
        }}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="d-flex flex-column gap-3">
            {submissionMessage && (
              <div
                className={`alert ${submissionClass} alert-dismissible fade show`}
              >
                {submissionMessage}
                <button
                  type="button"
                  className="btn-close"
                  data-testid="dismiss-message"
                  onClick={() => setSubmissionMessage(null)}
                />
              </div>
            )}

            <div>
              <label htmlFor="email" className="form-label">
                Email address
              </label>
              <Field
                name="email"
                className="form-control"
                id="email"
                placeholder="Your email address"
                disabled={!!email}
              />
              <ErrorMessage
                className="text-danger text-small mt-1"
                name="email"
                component="div"
                id="email_error"
              />
            </div>

            <div>
              <label htmlFor="reference" className="form-label">
                Booking reference
              </label>
              <Field
                name="reference"
                type="text"
                className="form-control"
                id="reference"
                placeholder="Your booking reference"
              />
              <ErrorMessage
                className="text-danger text-small mt-1"
                name="reference"
                component="div"
                id="reference_error"
              />
            </div>

            <Button className="w-100" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner-third animation-momentum-spin me-1" />{' '}
                  Submitting
                </>
              ) : (
                'Find booking'
              )}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FindBooking;

FindBooking.propTypes = {
  message: PropTypes.string,
};
